// extracted by mini-css-extract-plugin
export default {"left":"a7lRdB","external":"b7lRdB","center":"c7lRdB","right":"d7lRdB"};